import { createContext, useContext, useState, type ReactNode } from 'react'

interface BreadcrumbTitleContextValue {
  title: string | null
  setTitle: (title: string | null) => void
}

const BreadcrumbTitleContext = createContext<BreadcrumbTitleContextValue>({
  title: null,
  setTitle: () => {},
})

export function BreadcrumbTitleProvider({ children }: { children: ReactNode }) {
  const [title, setTitle] = useState<string | null>(null)
  return (
    <BreadcrumbTitleContext.Provider value={{ title, setTitle }}>
      {children}
    </BreadcrumbTitleContext.Provider>
  )
}

export function useBreadcrumbTitle() {
  return useContext(BreadcrumbTitleContext)
}
